import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import CompaniesPage from "./pages/companies/companies.page";
import PartnersPage from "./pages/partners/partners.page";
import UsersPage from "./pages/users/users.page";
import CustomersPage from "./pages/customers/customers.page";
import PackagingPage from "./pages/packaging/packaging.page";
import BillsPage from "./pages/bills/bills.page";
import FieldsPage from "./pages/customers/fields.page";
import RegistersPage from "./pages/registers/registers.page";
import LoansPage from "./pages/loans/loans.page";
import PartnerAccountsPage from "./pages/partner-accounts/partner-accounts.page";
import ExpensesPage from "./pages/expenses/expenses.page";
import RemindersPage from "./pages/reminders/reminders.page";
import ReportsPage from "./pages/reports/reports.page";
import CyclePage from "./pages/cycle/cycle.page";
import PaymentsPage from "./pages/loans/payments.page";
import AccountsPage from "./pages/accounts/accounts.page";
import FormRegisterPage from "./pages/registers/form.page";
import AuthPage from "./pages/auth/auth.page";
import { StorageService } from "./services/storage";
import { STORAGE } from "./constants";
import SelectPeriodPage from "./pages/select-period/select-period.page";
import BalancePage from "./pages/balance/balance.page";
import CustomerReport from "./pages/registers/customer-report";
import CreatePasswordPage from "./pages/auth/create-password.page";
import ResetPasswordPage from "./pages/auth/reset-password.page";
import RootAccountsPage from "./pages/root-accounts/root-accounts.page";
import { Toaster } from "react-hot-toast";
import NotFound from "./pages/not-found/not-fount.page";

declare const KTComponents: any;

const PrivateRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    KTComponents.init();
  }, [location]);

  useEffect(() => {
    const token = StorageService.get(STORAGE.TOKEN);
    const session = StorageService.get(STORAGE.USER);

    if (!token || !session || session.role !== "admin") {
      navigate("/auth/login");
    }
  }, []);

  return <Outlet />;
};

const PrivateRootRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    KTComponents.init();
  }, [location]);

  useEffect(() => {
    const token = StorageService.get(STORAGE.TOKEN);
    const session = StorageService.get(STORAGE.USER);

    if (!token || !session || session.role !== "root") {
      navigate("/auth/login");
    }
  }, []);

  return <Outlet />;
};

const HandleRoutes = () => {
  const session = StorageService.get(STORAGE.USER);

  return session?.role === "root" ? (
    <Routes>
      <Route element={<PrivateRootRoute />}>
        <Route path="/" element={<RootAccountsPage />} />
      </Route>
    </Routes>
  ) : (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<BalancePage />} />
        <Route path="/select-period" element={<SelectPeriodPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/balance" element={<BalancePage />} />
        <Route path="/register">
          <Route path="" element={<RegistersPage />} />
          <Route path="report" element={<CustomerReport />} />
          <Route path="form" element={<FormRegisterPage />} />
        </Route>
        <Route path="/partner-accounts" element={<PartnerAccountsPage />} />
        <Route path="/expenses" element={<ExpensesPage />} />
        <Route path="loans">
          <Route path="" element={<LoansPage />} />
          <Route path="payments" element={<PaymentsPage />} />
        </Route>
        <Route path="/reminders" element={<RemindersPage />} />

        <Route path="/configuration">
          <Route path="companies" element={<CompaniesPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="customers">
            <Route path="" element={<CustomersPage />} />
            <Route path="fields" element={<FieldsPage />} />
          </Route>
          <Route path="packaging" element={<PackagingPage />} />
          <Route path="bills" element={<BillsPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="cycle" element={<CyclePage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <BrowserRouter>
      <Routes>
        <Route path="/auth/login" element={<AuthPage />} />
        <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/create-password" element={<CreatePasswordPage />} />
        <Route path="/*" element={<HandleRoutes />} />
      </Routes>
    </BrowserRouter>
    <Toaster position="top-center" containerStyle={{ zIndex: 99999 }} />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
